import { useEffect } from "react";

const ConsultResultPage = () => {
  useEffect(() => {
    document.title = "상담 신청";
  }, []);

  useEffect(() => {
    if (typeof (window as any).fbq === "function") {
      (window as any).fbq("track", "CompleteRegistration");
    }
  }, []);

  return (
    <div className="main_container">
      <main
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "24px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor: "#4CAF50",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "24px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        <h1
          style={{
            fontSize: "24px",
            fontWeight: 700,
            marginBottom: "16px",
            color: "#333",
          }}
        >
          상담 신청이 완료되었습니다
        </h1>

        <p
          style={{
            fontSize: "16px",
            color: "#666",
            marginBottom: "8px",
            lineHeight: 1.6,
          }}
        >
          카카오톡 알림톡으로 안내 메시지를 보내드렸습니다.
        </p>

        <p
          style={{
            fontSize: "14px",
            color: "#999",
            marginBottom: "32px",
            lineHeight: 1.6,
          }}
        >
          카카오톡을 확인해주세요!
        </p>
      </main>
    </div>
  );
};

export default ConsultResultPage;